import { ChainEnum } from '@dynamic-labs/sdk-api';
import { findEmbeddedWalletFromVerifiedCredentials } from '../findEmbeddedWalletFromVerifiedCredentials/findEmbeddedWalletFromVerifiedCredentials.js';

const isEmbeddedWalletPresent = (jwt) => Boolean(findEmbeddedWalletFromVerifiedCredentials(jwt, ChainEnum.Evm) ||
    findEmbeddedWalletFromVerifiedCredentials(jwt, ChainEnum.Sol));

export { isEmbeddedWalletPresent };
